import React from "react";
import generatePassword from "generate-password";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import EditSuperAdminModal from "../../components/EditSuperAdminModal";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";
import {
  removeTaskerFromAuth,
  updateRetailerAdminLead,
  resetPassword,
  sendInvestorResetPasswordEmail,
} from "../../api/UserApi";
import AddAdminModal from "../../components/AddAdminModal";

const user_icon = require("../../assets/media/user.png");
const remove_icon = require("../../assets/media/stop.png");

class SuperInvestor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      investors: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });

      Firebase.getAllInvestor((investors) => {
        this.setState({ investors });
      });
    }
  }

  addSubAdmin = (name, email) => {
    const password = generatePassword.generate({
      length: 10,
      numbers: true,
    });
    Firebase.addInvestor(email, password)
      .then((uid) => {
        Firebase.writeInvestor(uid, {
          uid: uid,
          username: name,
          email,
          approved: true,
          shouldReset: true,
        });

        sendInvestorResetPasswordEmail(email, name, password);
      })
      .catch((err) => {
        alert(err);
      });
  };

  onEditUser = (username, email) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      Firebase.updateInvestorData(selectedUser.uid, {
        username,
        email,
      });

      updateRetailerAdminLead(selectedUser.uid, email);
    }
  };

  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };

  removeSuperAdmin = (item) => () => {
    const { uid } = item;
    Firebase.removeInvestor(uid);
    removeTaskerFromAuth(uid);
  };

  editSuperAdmin = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  render() {
    const { username, role, logo, brand, brand_name, investors, selectedUser } =
      this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container">
          <div className="home-content super-admins-container">
            <div className="user-content">
              <div>
                <div className="member-row">
                  <button
                    type="button"
                    className="btn add-user"
                    data-toggle="modal"
                    data-target="#add_admin"
                  >
                    Add Investor
                  </button>
                </div>
                <div className="member-row">
                  <p className="avatar-header">Profile</p>
                  <p className="member-name">Name</p>
                  <p className="member-email">Email</p>
                  <p className="member-name">UID</p>
                  <div className="sa-actions-container"></div>
                </div>
                {investors.map((item) => {
                  return (
                    <div className="member-row">
                      <img
                        className="avatar-header"
                        src={user_icon}
                        width="50"
                        alt="icon"
                      />
                      <div className="member-name name-container">
                        <p>{item.username}</p>
                        <img
                          src={remove_icon}
                          className="remove-icon"
                          alt="remove"
                          onClick={this.removeSuperAdmin(item)}
                        />
                      </div>
                      <p className="member-email">{item.email}</p>
                      <p className="member-name">{item.uid}</p>
                      <div className="sa-actions-container">
                        <button
                          type="button"
                          className="btn"
                          data-toggle="modal"
                          data-target="#edit_super_admin"
                          onClick={this.editSuperAdmin(item)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn"
                          data-toggle="modal"
                          data-target="#reset_password_super_admin"
                          onClick={this.editSuperAdmin(item)}
                        >
                          Reset password
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
        <AddAdminModal addUser={this.addSubAdmin} />
        <EditSuperAdminModal
          onSave={this.onEditUser}
          initialValues={selectedUser}
        />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default SuperInvestor;



// WEBPACK FOOTER //
// ./src/screens/SuperInvestor/index.js